import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TramitesRoutingModule} from './tramites-routing.module';
import {PrimeNgModule} from "../../shared/prime-ng/prime-ng.module";
import {SharedModule} from "../../shared/shared.module";
import {TramitesDisponiblesComponent} from "./components/tramites-disponibles/tramites-disponibles.component";
import {TramitesPreviosComponent} from "./components/tramites-previos/tramites-previos.component";
import {ProyectosModule} from "../proyectos/proyectos.module";
import {Ripple} from "primeng/ripple";
import {ListboxModule} from "primeng/listbox";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {AssignedUsersComponent} from "../../officials/asignaciones/components/assigned-users/assigned-users.component";
import {
    GeneralesProyectoComponent
} from "../proyectos/components/ver-proyecto/generales-proyecto/generales-proyecto.component";
import {
    GeneralesResumenComponent
} from "../proyectos/components/ver-proyecto/generales-resumen/generales-resumen.component";
import {SkeletonModule} from "primeng/skeleton";
import {InputGroupModule} from "primeng/inputgroup";
import {SkeletonComponent} from "./components/tramites-disponibles/skeleton/skeleton.component";

@NgModule({
    declarations: [
        TramitesDisponiblesComponent,
        TramitesPreviosComponent
    ],
    exports: [
        TramitesPreviosComponent
    ],
    imports: [
        CommonModule,
        TramitesRoutingModule,
        PrimeNgModule,
        SharedModule,
        Ripple,
        ListboxModule,
        ProyectosModule,
        ConfirmPopupModule,
        AssignedUsersComponent,
        GeneralesProyectoComponent,
        GeneralesResumenComponent,
        SkeletonModule,
        InputGroupModule,
        SkeletonComponent
    ]
})
export class TramitesModule {
}
